<template>
    <ConfirmDialog group="dialog" />
    <div class="p-grid">
        <!-- <div class="p-col-12 p-pb-0">
            <Button @click="$router.go(-1)" label="Go Back" icon="pi pi-angle-left" class="p-button-text p-mr-2 p-mb-2" />
        </div> -->
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4><strong>{{ $t('Receipt.list.Receipt Details')}}</strong></h4>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Receipt.list.Order ID')}}:</label>
                    <div class="p-col-12 p-md-10">{{ mydata.store_id }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Receipt.list.Category')}}:</label>
                    <div class="p-col-12 p-md-10">{{ mydata.category_name }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Receipt.list.Registration Date & Time')}}:</label>
                    <div class="p-col-12 p-md-10">{{ formatDateTime(mydata.created_receipt_date == null ? '-Empty-' : mydata.created_receipt_date) }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Receipt.list.Shop Name')}}:</label>
                    <div class="p-col-12 p-md-10">{{ mydata.store_name }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Receipt.list.Shop Address')}}:</label>
                    <div class="p-col-12 p-md-10">{{ mydata.store_address }}</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Receipt.list.Total Price')}}:</label>
                    <div class="p-col-12 p-md-10">{{ totalPrice }} WON</div>
                </div>
                <div class="p-field p-grid">
                    <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('Receipt.list.Receipt Type')}}:</label>
                    <div class="p-col-12 p-md-10">{{ mydata.receipt_type }}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="p-col-12 p-p-0">
        <div class="card">
            <div>
                <h5>{{ $t('Receipt.list.Order Summary')}}</h5>
            </div>
            <DataTable :value="pointHistory" :paginator="true" class="p-datatable-gridlines" :rows="10" dataKey="id" :rowHover="true" :loading="loading1" :filters="filters1" responsiveLayout="scroll" v-model:selection="selected">
                <!-- v-model:selection="selected" -->
                <ConfirmDialog group="dialog" />

                <template #empty> No Data found. </template>
                <template #loading> Loading data. Please wait. </template>

                <!-- <column selectionMode="multiple" style="width: 16px; text-align: center" /> -->
                <Column field="slNO" :header="$t('#')">
                    <template #body="{ index }">
                        <span class="p-column-title">Name</span>
                        {{ index + 1 }}
                    </template>
                </Column>
                <Column field="product_category" :header="$t('Receipt.list.Category')" style="min-width: 12rem" :sortable="true">
                    <template #body="{ data }">
                        <span class="p-column-title">Category</span>
                        {{ data.product_category == '' ? '-EMPTY-' : data.product_category }}
                    </template>
                </Column>
                <Column field="product_title" :header="$t('Receipt.list.Product Name')" style="min-width: 12rem" :sortable="true">
                    <template #body="{ data }">
                        <span class="p-column-title">Product Name</span>
                        {{ data.product_title }}
                    </template>
                </Column>
                <Column field="product_quantity" :header="$t('Receipt.list.Quantity')" style="min-width: 12rem" :sortable="true">
                    <template #body="{ data }">
                        <span class="p-column-title">Quantity</span>
                        {{ data.product_quantity }}
                    </template>
                </Column>
                <Column field="price" :header="$t('Receipt.list.Price Per Item (in WON)')" style="min-width: 12rem" :sortable="true">
                    <template #body="{ data }">
                        <span class="p-column-title">Price Per Item (in WON)</span>
                        {{ data.price }}
                    </template>
                </Column>
                <Column field="price" :header="$t('Receipt.list.Price (in WON)')" style="min-width: 12rem" :sortable="true">
                    <template #body="{ data }">
                        <span class="p-column-title">Price (in WON)</span>
                        {{ data.price * data.product_quantity }}
                    </template>
                </Column>
            </DataTable>
            <div class="p-d-flex p-jc-between p-mb-2 p-mt-3">
                <div>
                    <h5>{{ $t('Receipt.list.Total Amount') }}</h5>
                </div>
                <div>
                    <h5>{{ totalPrice }} WON</h5>
                </div>
            </div>
        </div>
    </div>
    <div class="p-col-12">
        <div class="p-d-flex p-jc-end">
            <div>
                <Button @click="$router.go(-1)" label="Back" class="p-button-outlined p-mr-2 p-mb-2" />
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import ReceiptService from '../../service/API/ReceiptService';
import formatDateTime from '../../mixin/mixinFunction';
// import {useRouter} from 'vue-router'
export default {
         mixins: [formatDateTime],

    data() {
        return {
            dropdownItems: [
                { name: 'male', code: 'male' },
                { name: 'female', code: 'female' },
                { name: 'others', code: 'others' },
            ],
            dropdownItem: null,
            mydata: {},
            pointHistory: [],
            totalPrice: '',
            loading1:true,
        };
    },
    created() {
        this.receiptService = new ReceiptService();
    },
    methods: {
        del(id) {
            this.$confirm.require({
                group: 'dialog',
                header: '확인',
                message: '삭제하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: ' 취소',
                accept: () => {
                    axios({ method: 'patch', url: `/user/delete`, data: { id: id, status: 'deleted' } }).then((res) => {
                        console.warn(res);
                        this.$router.push({ name: 'User' });
                    });

                    this.$toast.add({ severity: 'info', summary: '삭제', detail: '성공적으로 삭제되었습니다.', life: 3000 });
                },
                reject: () => {
                    this.$toast.add({ severity: 'error', summary: '오류가 발생했습니다', detail: '취소되었습니다', life: 3000 });
                },
            });
        },
    },
    mounted() {
        let getReceipt = JSON.parse(localStorage.getItem('myreceipt'));
        this.receiptService.receiptDetails(getReceipt.userId, getReceipt.storeId).then((res) => {
            this.mydata = res.receiptData[0];
            this.totalPrice = res.receiptData[0].amount;
            this.pointHistory = res.receiptProductData;
            this.loading1 = false;
            let priceArray = res.receiptProductData.map((item) => ({ total: item.product_quantity * item.price }));
            this.totalPrice = 0;
            for (let i = 0; i < priceArray.length; i++) {
                this.totalPrice += priceArray[i].total;
            }
            console.log(res.receiptProductData);
            // // console.log(this.mydata.nickname)
            // console.log(res.point_history);
        });
    },
};
</script>

<style scoped>
.p-fluid .p-button {
    width: auto;
}
</style>
